<template>
  <div>
  <!-- ตารางรถใน report -->
  <CCard class="bg-style2" style="min-height:200px;">
      <CCardHeader class="bg-gradient-dark text-white" style="border-top-left-radius: 1rem; border-top-right-radius: 1rem ">
        <span class="font-weight-bold h6">
          <CIcon :name="icon" size="lg"/> {{ caption }}
        </span>

      </CCardHeader>

      <CCardBody>
        <CRow>
          <CCol>
            <CDataTable
              :hover="true"
              :bordered="true"
              :small="true"
              :fixed="true"
              :fields="fields"
              :items="sortedAllCars"
              :items-per-page="small ? 50 : 5"
              pagination
            >
              <template #index="{ index }">
                <td>{{ index + 1 }}</td>
              </template>

              <template #reportDescription="{ item }">
                <td>{{ item.reportDescription }}</td>
              </template>

              <template #plate="{ item }">
                <td>{{ item.plate }}</td>
              </template>

              <template #carType="{ item }">
                <td>{{ item.carType }}</td>
              </template>

              <template #distance="{ item }">
                <td>{{ formatDistance(item.distanceKm) }}</td>
              </template>

              <template #carRequestStatus="{ item }">
                <td>{{ item.carRequestStatus }}</td>
              </template>

              <template #actions="{ item }">
                <td class="text-center">
                  <template v-if="item.carRequestStatus === 'pending' && canEditCars">
                    <CButton
                      v-c-tooltip.hover.click="'อนุมัติ'"
                      color="success"
                      size="sm"
                      shape="pill"
                      variant="outline"
                      class="mr-1"
                      @click="approveCar(item)"
                    >
                      <CIcon name="cil-check" />
                    </CButton>

                    <CButton
                      v-c-tooltip.hover.click="'ปฏิเสธ'"
                      color="danger"
                      size="sm"
                      shape="pill"
                      class="mr-1"
                      variant="outline"
                      @click="rejectCar(item)"
                    >
                      <CIcon name="cil-x" />
                    </CButton>
                  </template>
                  <CButton 
                    v-c-tooltip.hover.click="'ซูม'"
                    size="sm" 
                    color="warning" 
                    shape="pill" 
                    variant="outline" 
                    class="mr-1" 
                    @click="zoomcar(item)" 
                  >
                    <CIcon name="cil-zoom-in"/>
                  </CButton>
                  <CButton 
                    v-c-tooltip.hover.click="'เส้นทาง'"
                    size="sm" 
                    color="info" 
                    shape="pill" 
                    variant="outline" 
                    class="mr-1" 
                    @click="createPolyline(item)" 
                  >
                    <CIcon name="cil-Map"/>
                  </CButton>
                </td>
              </template>
            </CDataTable>
          </CCol>
        </CRow>
        <div class="card-header-actions mt-1">
            <CButton 
              v-c-tooltip.hover.click="'เพิ่ม'"
              color="info" 
              size="sm"
              shape="pill"
              variant="outline"
              class="mt-2"
              @click="openModal"
              :disabled="!canEditCars"
              
                >
              <CIcon name="cil-plus" class="me-2"/>
          </CButton>
        </div>
      </CCardBody>
    </CCard>

    <!-- Modal เลือกรถ -->
    <CModal
      title="กรุณาเลือกรถ"
      :show.sync="showModal"
      size="lg"
      :centered="true"
      class="modal-rounded"
    >
      <template #body-wrapper>
        <div style="max-height: 400px; overflow-y: auto; padding: 1rem;">
          <table class="table table-hover">
            <thead>
              <tr>
                <th>
                  <input type="checkbox" v-model="selectAll" @change="toggleSelectAll" :disabled="!canEditCars"/>
                </th>
                <th>ยี่ห้อ/รุ่น</th>
                <th>ป้ายทะเบียน</th>
                <th>ระยะห่าง</th>
                <th>สถานะ</th>
              </tr>
            </thead>
            <tbody>
              <tr 
                v-for="car in modalCarsSorted" 
                :key="car._id"
                :class="{ 
                  'selected-row': selectedCarIds.includes(car._id),
                  'inactive-row': car.status !== 'active'
                }"
              >
                <td class="text-start">
                  <input
                    type="checkbox"
                    :value="car._id"
                    v-model="selectedCarIds"
                    :disabled="car.status !== 'active' || !canEditCars"
                  />
                </td>
                <td>{{ car.titleText }}</td>
                <td>{{ car.descriptionText }}</td>
                <td>{{ formatDistance(car.distanceKm) }}</td>
                <td>{{ car.status }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </template>
      <template #footer>
        <CButton class="mr-2" size="sm" color="danger" shape="pill" variant="outline" @click="closeModal">
          <span class="font-weight-bold pr-1 pl-1"><CIcon name="cil-ban" size="sm"/> CANCEL </span>
        </CButton>
        <CButton size="sm" color="success" shape="pill" variant="outline" @click="addCarsToReport" :disabled="selectedCarIds.length === 0 || !canEditCars">
          <span class="font-weight-bold pr-1 pl-1"><CIcon name="cil-save" size="sm"/> SUBMIT </span>
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import { mapGetters } from 'vuex';
import { calculateDistancesBatch } from '@/utils/distanceService';

export default {
  name: "CarAsset",
  props: {
    icon: { type: String, default: "cil-car" },
    caption: { type: String, default: "รถ" },
    caseId: { type: String, required: true }
  },
  data() {
    return {
      showModal: false,
      selectedCarIds: [],
      selectAll: false,
      fields: [
        { key: "index", label: "#", _style: "width:20px; text-align:center" },
        // { key: "reportDescription", label: "รายละเอียดคำขอ" },
        { key: "plate", label: "ป้ายทะเบียน" },
        { key: "carType", label: "รุ่น/ประเภท" },
        { key: "distance", label: "ระยะห่าง" },
        { key: "carRequestStatus", label: "สถานะคำขอ" },
        { key: "actions", label: "การจัดการ", _style: "width:220px; text-align:center" },
      ],
      objs: { allCars: [] },
      modalCarsWithDistance: [], // สำหรับเก็บข้อมูลรถพร้อมระยะทาง
      isLoadingDistances: false,
    };
  },

  created() {
    this.$store.dispatch("Dashboard/reports", {});
    this.$store.dispatch("Auth/fetchUsers")
    // this.user = this.users[0] || null;
    console.log("👥 [CarAsset] selectedUser:", this.selectedUser);
  },

  computed: {
    ...mapGetters({ 
      caseData: 'Dashboard2/case',
      reports: "Dashboard/reports",
      selectedUser: "Auth/selectedUser" 
     }),
    isCaseOpen() {
      return this.caseData && this.caseData.caseManagement
        ? this.caseData.caseManagement.isOpen
        : false;
    },

    allRoles() {
      return this.selectedUser?.authen?.flatMap(a => a.roles) || [];
    },
    
    allCars() {
      return this.$store.state.Car.cars || [];
    },

    canEditCars() {
      return this.isCaseOpen && this.allRoles.includes("2") || this.allRoles.includes("3");
    },
    reportCars() {
      const reports = this.$store.state.Dashboard.reports || [];
      const report = reports.find(r => r._id === this.caseId);
      if (!report || !report.cars) return [];
      
      return report.cars.map(c => {
        const titleObj = c.title?.find(t => t.key === 'th') || c.title?.[0];
        const descObj = c.description?.find(d => d.key === 'th') || c.description?.[0];

        return {
          _id: c._id,
          title: titleObj?.value || '-',
          description: descObj?.value || '-',
          status: c.status || 'inactive',
          request_status: c.request_status || 'pending'
        };
      });
    },
    availableCars() {
      const reportCarIds = this.reportCars.map(c => c._id);
      return this.allCars.filter(c => !reportCarIds.includes(c._id));
    },

    caseLocation() {
      const reports = this.$store.state.Dashboard.reports || [];
      const fromList = reports.find(r => r._id === this.caseId)?.location || null;
      const fromDetail = this.caseData?.location || null;
      return fromList || fromDetail || null;
    },

    modalCars() {
      // Return basic car info without distance (distance will be calculated async)
      return this.availableCars.map(car => {
        const titleObj = car.title?.find(t => t.key === 'th') || car.title?.[0];
        const descriptionObj = car.description?.find(d => d.key === 'th') || car.description?.[0];

        return {
          ...car,
          titleText: titleObj?.value || '-',
          descriptionText: descriptionObj?.value || '-',
          distanceKm: null // Will be populated by watch handler
        };
      });
    },

    // เรียงรถจากใกล้ไปไกล (null จะอยู่หลังสุด)
    modalCarsSorted() {
      // Use modalCarsWithDistance if available, otherwise use modalCars
      const carsToSort = this.modalCarsWithDistance.length > 0 ? this.modalCarsWithDistance : this.modalCars;
      return [...carsToSort].sort((a, b) => {
        if (a.distanceKm == null && b.distanceKm == null) return 0;
        if (a.distanceKm == null) return 1;
        if (b.distanceKm == null) return -1;
        return a.distanceKm - b.distanceKm;
      });
    },

    // เรียงรายการรถในตาราง: pending ก่อน และรายการใหม่อยู่บนสุดในแต่ละกลุ่ม
    sortedAllCars() {
      const statusOrder = (s) => (s === 'pending' ? 0 : 1);
      return [...this.objs.allCars].sort((a, b) => {
        const diffStatus = statusOrder(a.carRequestStatus) - statusOrder(b.carRequestStatus);
        if (diffStatus !== 0) return diffStatus;
        // เรียงตาม reportCarIndex (0 = ใหม่สุด, 1 = รองลงมา, ...)
        return (a.reportCarIndex || 0) - (b.reportCarIndex || 0);
      });
    },
    
  },
  watch: {
      selectedCarIds(val) {
        this.selectAll = val.length === this.availableCars.filter(c => c.status === 'active').length;
      },

      // Watch for modal cars and case location to calculate distances
      modalCars: {
        handler(newCars) {
          if (!newCars || newCars.length === 0) {
            this.modalCarsWithDistance = [];
            return;
          }

          const caseLatLng = this.getLatLngFromLocation(this.caseLocation);
          if (!caseLatLng) {
            this.modalCarsWithDistance = newCars.map(car => ({ ...car, distanceKm: null }));
            return;
          }

          // Calculate distances using Google Maps DistanceMatrixService
          this.calculateModalCarDistances(newCars, caseLatLng);
        },
        immediate: true
      },

      caseLocation: {
        handler() {
          // Recalculate distances when case location changes
          if (this.modalCars && this.modalCars.length > 0) {
            const caseLatLng = this.getLatLngFromLocation(this.caseLocation);
            if (caseLatLng) {
              this.calculateModalCarDistances(this.modalCars, caseLatLng);
            }
          }
        }
      },

      reports: {
        immediate: true,
        handler(value) {
          if (!value || !value.length) {
            this.objs.allCars = [];
            return;
          }

          const report = value.find(r => r._id === this.caseId);
          if (!report || !report.cars) {
            this.objs.allCars = [];
            return;
          }

          const caseLatLng = this.getLatLngFromLocation(
            report.location || this.caseData?.location || null
          );

          // Prepare cars data first
          const carsData = report.cars.map((c, idx) => {
            const plate = c.description?.find(d => d.key === "plate")?.value || "-";
            const carType = c.title?.find(t => t.key === "th")?.value || "-";
            const carLatLng = this.getLatLngFromLocation(c.coordinates || c.location || null);

            return {
              reportId: report._id,
              reportDescription: report.description || "-",
              plate,
              carType,
              carRequestStatus: c.request_status || "pending",
              carId: c._id,
              reportDocId: report._id,
              carLatLng,
              distanceKm: null, // Will be calculated
              reportCarIndex: idx, // เก็บ index จาก report.cars
            };
          });

          // Calculate distances using Google Maps DistanceMatrixService
          if (caseLatLng) {
            this.calculateReportCarDistances(carsData, caseLatLng);
          } else {
            this.objs.allCars = carsData;
          }
        }
      },

      selectedUser: {
        handler(newUser) {
          console.log("Selected user changed:", newUser);
        },
        deep: true,
        immediate: true
      },

      
    },
  methods: {
    zoomcar(item) {
      try {
        const reports = this.$store.state.Dashboard.reports || [];
        const reportId = item.reportDocId || item.reportId;
        const report = reports.find(r => r._id === reportId);
        const car = report && Array.isArray(report.cars)
          ? report.cars.find(c => c._id === item.carId)
          : null;
        const latLng = this.getLatLngFromLocation(
          (car && (car.coordinates || car.location)) || null
        );
        if (latLng && Number.isFinite(latLng.lat) && Number.isFinite(latLng.lng)) {
          // ดึง title จาก car object
          let title = item.carType || '-';
          if (car && car.title) {
            const titleObj = car.title.find(t => t.key === 'th') || car.title[0];
            title = titleObj?.value || item.carType || '-';
          }
          // ดึง plate จาก item หรือ car
          const plate = item.plate || (car && car.description?.find(d => d.key === 'plate')?.value) || '-';
          
          this.$emit('zoom-to', { 
            lat: latLng.lat, 
            lng: latLng.lng, 
            zoom: 16,
            title: title,
            plate: plate,
            label: `${title} (${plate})`
          });
        } else {
          Swal.fire({ icon: 'info', title: 'ไม่พบพิกัดของรถ', timer: 1200, showConfirmButton: false });
        }
      } catch (e) {
        Swal.fire({ icon: 'error', title: 'ซูมไม่สำเร็จ', text: 'เกิดข้อผิดพลาดในการค้นหาพิกัด' });
      }
    },
    async createPolyline(item) {
      try {
        const reports = this.$store.state.Dashboard.reports || [];
        const reportId = item.reportDocId || item.reportId;
        const report = reports.find(r => r._id === reportId);
        
        if (!report) {
          Swal.fire({ icon: 'warning', title: 'ไม่พบข้อมูลรายงาน', timer: 1500, showConfirmButton: false });
          return;
        }

        // หาตำแหน่งของเหตุการณ์
        const caseLatLng = this.getLatLngFromLocation(
          report.location || this.caseData?.location || null
        );
        
        if (!caseLatLng) {
          Swal.fire({ icon: 'warning', title: 'ไม่พบพิกัดของเหตุการณ์', timer: 1500, showConfirmButton: false });
          return;
        }

        // หาตำแหน่งของรถ
        const car = report && Array.isArray(report.cars)
          ? report.cars.find(c => c._id === item.carId)
          : null;
        
        const carLatLng = this.getLatLngFromLocation(
          (car && (car.coordinates || car.location)) || null
        );

        if (!carLatLng) {
          Swal.fire({ icon: 'warning', title: 'ไม่พบพิกัดของรถ', timer: 1500, showConfirmButton: false });
          return;
        }

        // ตรวจสอบว่า Google Maps API พร้อมหรือไม่
        if (!window.google || !window.google.maps || !window.google.maps.DirectionsService) {
          Swal.fire({ 
            icon: 'warning', 
            title: 'Google Maps API ยังไม่พร้อม', 
            text: 'กรุณารอสักครู่แล้วลองอีกครั้ง',
            timer: 2000, 
            showConfirmButton: false 
          });
          return;
        }

        // ใช้ DirectionsService เพื่อหาเส้นทาง
        const directionsService = new window.google.maps.DirectionsService();
        
        directionsService.route(
          {
            origin: caseLatLng,
            destination: carLatLng,
            travelMode: window.google.maps.TravelMode.DRIVING,
            provideRouteAlternatives: false, // ใช้เส้นทางเดียว (เส้นทางที่สั้นที่สุด/เร็วที่สุด)
          },
          (result, status) => {
            if (status === 'OK' && result.routes && result.routes.length > 0) {
              // ใช้เส้นทางแรก (มักจะเป็นเส้นทางที่สั้นที่สุด/เร็วที่สุด)
              const route = result.routes[0];
              
              // แปลงเส้นทางเป็น array of {lat, lng}
              const path = [];
              if (route.legs && route.legs.length > 0) {
                route.legs.forEach(leg => {
                  if (leg.steps && leg.steps.length > 0) {
                    leg.steps.forEach(step => {
                      if (step.path && step.path.length > 0) {
                        step.path.forEach(point => {
                          // ตรวจสอบว่า point มี methods lat() และ lng() หรือไม่
                          if (typeof point.lat === 'function' && typeof point.lng === 'function') {
                            path.push({ lat: point.lat(), lng: point.lng() });
                          } else if (typeof point.lat === 'number' && typeof point.lng === 'number') {
                            path.push({ lat: point.lat, lng: point.lng });
                          }
                        });
                      }
                    });
                  }
                });
              }

              // ตรวจสอบว่า path มีข้อมูลหรือไม่
              if (path.length === 0) {
                Swal.fire({ 
                  icon: 'warning', 
                  title: 'ไม่สามารถสร้างเส้นทางได้', 
                  text: 'ไม่พบข้อมูลเส้นทาง',
                  timer: 2000, 
                  showConfirmButton: false 
                });
                return;
              }

              // Emit event พร้อมกับ route data (ไม่แสดง SweetAlert เมื่อสำเร็จ)
              this.$emit('show-route', {
                origin: caseLatLng,
                destination: carLatLng,
                path: path,
                distance: route.legs.reduce((sum, leg) => sum + (leg.distance?.value || 0), 0),
                duration: route.legs.reduce((sum, leg) => sum + (leg.duration?.value || 0), 0),
                carInfo: {
                  plate: item.plate,
                  carType: item.carType,
                  carId: item.carId
                }
              });
              // ไม่แสดง SweetAlert เมื่อสำเร็จ - เส้นทางจะแสดงบนแผนที่ทันที
            } else {
              Swal.fire({ 
                icon: 'error', 
                title: 'ไม่สามารถหาเส้นทางได้', 
                text: status === 'ZERO_RESULTS' ? 'ไม่พบเส้นทางระหว่างจุดสองจุดนี้' : 'เกิดข้อผิดพลาดในการหาเส้นทาง',
                timer: 2000, 
                showConfirmButton: false 
              });
            }
          }
        );
      } catch (error) {
        console.error('Error creating polyline:', error);
        Swal.fire({ 
          icon: 'error', 
          title: 'เกิดข้อผิดพลาด', 
          text: 'ไม่สามารถสร้างเส้นทางได้',
          timer: 2000, 
          showConfirmButton: false 
        });
      }
    },
    openModal() {
      if (!this.canEditCars) return;
      this.showModal = true;
      this.selectedCarIds = [];
      this.selectAll = false;
      this.$store.dispatch("Car/cars");
    },
    closeModal() {
      this.showModal = false;
      this.selectedCarIds = [];
      this.selectAll = false;
    },
    toggleSelectAll() {
      if (this.selectAll) {
        this.selectedCarIds = this.availableCars.filter(c => c.status === 'active').map(c => c._id);
      } else {
        this.selectedCarIds = [];
      }
    },
    addCarsToReport() {
      if (!this.canEditCars || !this.selectedCarIds.length) return;

      const selectedCars = this.modalCars.filter(c => this.selectedCarIds.includes(c._id));

      this.$store.dispatch("Car/addCarsToReport", {
        reportId: this.caseId,
        carIds: this.selectedCarIds
      })
      .then(() => Promise.all(this.selectedCarIds.map(id => this.$store.dispatch("Car/updateCar", {
        _id: id,
        status: "inactive",
        request_status: "pending"
      }))))
      .then(() => {
        selectedCars.forEach(car => {
          this.$store.dispatch("Dashboard2/logCaseAction", {
            caseId: this.caseId,
            by: "ผู้ใช้ระบบ",
            carId: car._id,
            carAction: "added",
            reason: `เพิ่มรถ ${car.titleText} (${car.descriptionText})`
          });
        });
        this.closeModal();
        Swal.fire({ icon: 'success', title: 'สำเร็จ!', text: `รถถูกเพิ่มเรียบร้อย`, timer: 2000, showConfirmButton: false });
      });
    },
    removeCarFromReport(car) {
      if (!this.canEditCars) return;

      const carTitle = car.title || '-';
      const carPlate = car.description || '-';

      Swal.fire({
        title: 'คุณแน่ใจหรือไม่?',
        text: `รถ ${carTitle} (${carPlate}) จะถูกลบออกจากรายงาน`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'ลบทันที',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (!result.isConfirmed) return;

        this.$store.dispatch("Car/removeCarsFromReport", {
          reportId: this.caseId,
          carIds: [car._id]
        })
        .then(() => this.$store.dispatch("Car/updateCar", { _id: car._id, status: "active", request_status: null }))
        .then(() => {
          const report = this.$store.state.Dashboard.reports.find(r => r._id === this.caseId);
          if (report) report.cars = report.cars.filter(c => c._id !== car._id);

          this.$store.dispatch("Dashboard2/logCaseAction", {
            caseId: this.caseId,
            by: "ผู้ใช้ระบบ",
            carId: car._id,
            carAction: "removed",
            reason: `ลบรถ ${carTitle} (${carPlate})`
          });

          Swal.fire({ icon: 'success', title: 'สำเร็จ!', text: 'รถถูกลบออกจากรายงานเรียบร้อยแล้ว', timer: 1500, showConfirmButton: false });
        });
      });
    },
    async approveCar(item) {
      const { isConfirmed } = await Swal.fire({
        title: "คุณแน่ใจหรือไม่?",
        text: `คุณต้องการอนุมัติรถ ${item.plate} ใช่หรือไม่`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "ใช่, อนุมัติ",
        cancelButtonText: "ยกเลิก",
      });
      if (!isConfirmed) return;

      try {
        // อัปเดตสถานะรถ
        await this.$store.dispatch("Car/updateCar", {
          _id: item.carId,
          request_status: "approved",
          status: "inactive",
        });

        // บันทึก log action
        await this.$store.dispatch("Dashboard2/logCaseAction", {
          caseId: item.reportId,
          by: "ผู้ใช้ระบบ",
          carId: item.carId,
          carAction: "approved",
          reason: `อนุมัติรถ ${item.plate} (${item.carType})`,
        });

        // update local state
        this.objs.allCars = this.objs.allCars.map(c =>
          c.carId === item.carId ? { ...c, carRequestStatus: "approved" } : c
        );

        Swal.fire({
          icon: "success",
          title: "อนุมัติเรียบร้อย",
          timer: 1500,
          showConfirmButton: false,
        });
      } catch (err) {
        console.error(err);
        Swal.fire({
          icon: "error",
          title: "เกิดข้อผิดพลาด",
          text: "ไม่สามารถอนุมัติได้",
        });
      }
    },

    async rejectCar(item) {
      const { isConfirmed } = await Swal.fire({
        title: "คุณแน่ใจหรือไม่?",
        text: `รถ ${item.plate} จะถูกปฏิเสธและลบออกจากรายงาน`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "ใช่, ปฏิเสธ",
        cancelButtonText: "ยกเลิก",
      });
      if (!isConfirmed) return;

      try {
        // อัปเดตสถานะรถ
        await this.$store.dispatch("Car/updateCar", {
          _id: item.carId,
          request_status: null,
          status: "active",
        });

        // ลบจาก report
        await this.$store.dispatch("Car/removeCarsFromReport", {
          reportId: item.reportDocId,
          carIds: [item.carId],
        });

        // บันทึก log action
        await this.$store.dispatch("Dashboard2/logCaseAction", {
          caseId: item.reportId,
          by: "ผู้ใช้ระบบ",
          carId: item.carId,
          carAction: "rejected",
          reason: `ปฏิเสธรถ ${item.plate} (${item.carType})`,
        });

        // update local state
        this.objs.allCars = this.objs.allCars.filter(c => c.carId !== item.carId);

        const report = this.reports.find(r => r._id === item.reportDocId);
        if (report) report.cars = report.cars.filter(c => c._id !== item.carId);

        Swal.fire({
          icon: "success",
          title: "ปฏิเสธเรียบร้อย",
          timer: 1500,
          showConfirmButton: false,
        });
      } catch (err) {
        console.error(err);
        Swal.fire({
          icon: "error",
          title: "เกิดข้อผิดพลาด",
          text: "ไม่สามารถปฏิเสธได้",
        });
      }
    },

    getLatLngFromLocation(loc) {
      if (!loc) return null;

      // 1) GeoJSON { coordinates: [lng, lat] }
      if (loc && Array.isArray(loc.coordinates) && loc.coordinates.length >= 2) {
        const [lng, lat] = loc.coordinates;
        if (typeof lat === 'number' && typeof lng === 'number') {
          return { lat, lng };
        }
      }

      // 2) Plain object { lat, lng } หรือ { latitude, longitude }
      const latObj = loc.lat ?? loc.latitude;
      const lngObj = loc.lng ?? loc.longitude;
      if (typeof latObj === 'number' && typeof lngObj === 'number') {
        return { lat: latObj, lng: lngObj };
      }

      // 3) Bare array: [lat, lng] หรือ [lng, lat]
      if (Array.isArray(loc) && loc.length >= 2) {
        const a = Number(loc[0]);
        const b = Number(loc[1]);
        if (Number.isFinite(a) && Number.isFinite(b)) {
          // ถ้าค่าแรกดูเหมือน lat (|lat| <= 90) ให้ตีว่า [lat, lng], ไม่งั้น [lng, lat]
          if (Math.abs(a) <= 90 && Math.abs(b) <= 180) {
            return { lat: a, lng: b };
          } else {
            return { lat: b, lng: a };
          }
        }
      }

      return null;
    },

    /**
     * Calculate distances for modal cars using Google Maps DistanceMatrixService
     */
    async calculateModalCarDistances(cars, caseLatLng) {
      if (!cars || cars.length === 0 || !caseLatLng) {
        this.modalCarsWithDistance = cars || [];
        return;
      }

      this.isLoadingDistances = true;

      try {
        // Extract car coordinates
        const carCoordinates = cars.map(car => {
          return this.getLatLngFromLocation(car.coordinates || car.location || null);
        });

        // Filter out cars without valid coordinates
        const validCars = [];
        const validCoordinates = [];
        cars.forEach((car, index) => {
          const coord = carCoordinates[index];
          if (coord) {
            validCars.push({ car, index });
            validCoordinates.push(coord);
          }
        });

        if (validCoordinates.length === 0) {
          this.modalCarsWithDistance = cars.map(car => ({ ...car, distanceKm: null }));
          this.isLoadingDistances = false;
          return;
        }

        // Calculate distances in batch
        const distances = await calculateDistancesBatch(caseLatLng, validCoordinates);

        // Merge distances back into cars
        const carsWithDistance = cars.map((car, index) => {
          const validCarIndex = validCars.findIndex(vc => vc.index === index);
          if (validCarIndex >= 0) {
            return { ...car, distanceKm: distances[validCarIndex] };
          }
          return { ...car, distanceKm: null };
        });

        this.modalCarsWithDistance = carsWithDistance;
      } catch (error) {
        console.error('Error calculating modal car distances:', error);
        this.modalCarsWithDistance = cars.map(car => ({ ...car, distanceKm: null }));
      } finally {
        this.isLoadingDistances = false;
      }
    },

    /**
     * Calculate distances for report cars using Google Maps DistanceMatrixService
     */
    async calculateReportCarDistances(carsData, caseLatLng) {
      if (!carsData || carsData.length === 0 || !caseLatLng) {
        this.objs.allCars = carsData || [];
        return;
      }

      try {
        // Extract car coordinates
        const carCoordinates = carsData.map(car => car.carLatLng);

        // Filter out cars without valid coordinates
        const validCars = [];
        const validCoordinates = [];
        carsData.forEach((car, index) => {
          if (car.carLatLng) {
            validCars.push({ car, index });
            validCoordinates.push(car.carLatLng);
          }
        });

        if (validCoordinates.length === 0) {
          this.objs.allCars = carsData.map(car => {
            const { carLatLng, ...rest } = car;
            return rest;
          });
          return;
        }

        // Calculate distances in batch
        const distances = await calculateDistancesBatch(caseLatLng, validCoordinates);

        // Merge distances back into cars
        const carsWithDistance = carsData.map((car, index) => {
          const validCarIndex = validCars.findIndex(vc => vc.index === index);
          const { carLatLng, ...rest } = car;
          if (validCarIndex >= 0) {
            return { ...rest, distanceKm: distances[validCarIndex] };
          }
          return { ...rest, distanceKm: null };
        });

        this.objs.allCars = carsWithDistance;
      } catch (error) {
        console.error('Error calculating report car distances:', error);
        this.objs.allCars = carsData.map(car => {
          const { carLatLng, ...rest } = car;
          return rest;
        });
      }
    },

      // แสดงสวยๆ 2 ตำแหน่ง พร้อมหน่วย
    formatDistance(km) {
      if (km == null) return '-';
      if (km < 1) {
        return `${Math.round(km * 1000)} m`;
      }
      return `${km.toFixed(2)} km`;
    },
  },

  mounted() {
    this.$store.dispatch("Car/cars");
    this.$store.dispatch("Car/fetchReport", this.caseId); 
  }
};
</script>

<style scoped>
.selected-row {
  background-color: #d1ecf1;
}
.inactive-row {
  background-color: #f8d7da;
  color: #721c24;
}

::v-deep .modal-rounded .modal-content {
  border-radius: 1rem !important;
}
</style>
